<template>
<b-row>
  <Tracking/>
  <b-col class="text-center">
    <h2 class="text-primary" style="margin-top: 30px;">Aguarde, vamos direcionar você para o grupo no whatsapp</h2>
    <br/>
    <spinner/>
  </b-col>
</b-row>
</template>

<script>
import Spinner from './Spinner.vue';
import Tracking from "./Tracking";

export default {
  name: "Mentoria",
  data() {
    return {

    };
  },
  methods: {
    
  },
  mounted() {
    setTimeout(function() {
      window.location.href = "https://chat.whatsapp.com/Co11hWpkWvBLXxGf0SwnRv";
    }, 1000);

  },
  components: { Tracking, Spinner }
};
</script>